import { AppRouteProps } from "@bsm/component";
import { SchoolHolidayContainer } from "./container/SchoolHolidayContainer";
import { SchoolHolidayCreateRoutes } from "./views/create/SchoolHolidayCreateRoutes";

export const SchoolHolidayRoutes: Array<AppRouteProps> = [
    {
        path: "school-holiday",
        title: "BSMRH.Holiday.Title.SchoolHolidays",
        element: <SchoolHolidayContainer />,
        children: [
            ...SchoolHolidayCreateRoutes
        ]
    }
];